import { defineMessages } from 'react-intl';

export const subItemUsageRecordMessages = defineMessages({
    usageRecords: {
        id: 'usage-records',
        defaultMessage: 'Usage record',
    },
    records: {
        id: 'records',
        defaultMessage: 'Records',
    },
    record: {
        id: 'record',
        defaultMessage: 'Record',
    },
    billingPeriodEnd: {
        id: 'billing-period-end',
        defaultMessage: 'Billing period end',
    },
    billingPeriodStart: {
        id: 'billing-period-start',
        defaultMessage: 'Billing period start',
    },
});
